import { RotateCcw } from "lucide-react";
import type { ProsthesisServiceRow } from "./types";
import { rotuloDoMaterialDoServico } from "@/components/prosthesis/rotulo-do-material";

type Props = {
  services: ProsthesisServiceRow[];
  /** Quando informado, mostra um botão de retrabalho ao lado de cada serviço já concluído —
   *  usado só na visão de card, pra pedir retrabalho sem precisar abrir o pedido. */
  onRequestRework?: (service: ProsthesisServiceRow) => void;
};

/** Uma linha por serviço — nome + dente/região em destaque, material e cor como
 *  detalhe secundário na mesma linha. Usado tanto na lista quanto nos cards de Prótese. */
export function ProsthesisOrderServiceLines({ services, onRequestRework }: Props) {
  if (services.length === 0) {
    return <span className="text-zinc-400 dark:text-muted-foreground/60">—</span>;
  }
  return (
    <div className="flex flex-col gap-1">
      {services.map((s) => {
        const detail = [rotuloDoMaterialDoServico(s), s.shadeOption?.code]
          .filter(Boolean)
          .join(" · ");
        const canRequestRework = onRequestRework && s.status === "CONCLUIDO";
        return (
          <div key={s.id} className="flex items-center justify-between gap-2">
            <p className="min-w-0 truncate">
              <span className="font-medium text-zinc-900 dark:text-foreground">
                {s.serviceCategory.label}
                {s.teeth ? ` (${s.teeth})` : ""}
              </span>
              {detail && <span className="text-zinc-500 dark:text-muted-foreground"> · {detail}</span>}
            </p>
            {canRequestRework && (
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  onRequestRework(s);
                }}
                title="Solicitar retrabalho"
                aria-label="Solicitar retrabalho"
                className="inline-flex h-6 shrink-0 items-center gap-1 rounded-md border border-red-200 px-1.5 text-[10.5px] font-semibold text-red-600 transition-colors hover:bg-red-50 dark:border-red-900/50 dark:text-red-400 dark:hover:bg-red-950/30"
              >
                <RotateCcw className="h-3 w-3" />
                Retrabalho
              </button>
            )}
          </div>
        );
      })}
    </div>
  );
}
